module.exports = __webpack_public_path__ + "img/PPMP18.f807b3c3.png";